function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
/* eslint-disable complexity -- Contains long lists that don't affect readability */ import { isIon, isSafariDesktop } from '../../utils/device-type';
import { TextTrackMimeType } from '../../core/player/text-track-mime-type';
import { TapeBundle } from './tape.enums';
var tapeModule = null;
export function loadTapeModuleCached() {
    return tapeModule;
}
export function loadTapeModule() {
    return _loadTapeModule.apply(this, arguments);
}
function _loadTapeModule() {
    _loadTapeModule = _async_to_generator(function() {
        var playerConfig, device, subtitlesFormat, tapeBundle;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            playerConfig = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, device = _arguments.length > 1 ? _arguments[1] : void 0, subtitlesFormat = _arguments.length > 2 ? _arguments[2] : void 0;
            tapeBundle = getTapeBundle(playerConfig, device, subtitlesFormat);
            return [
                2,
                getDefaultTapeBundle(tapeBundle)
            ];
        });
    });
    return _loadTapeModule.apply(this, arguments);
}
function getDefaultTapeBundle(tapeBundle) {
    return _getDefaultTapeBundle.apply(this, arguments);
}
function _getDefaultTapeBundle() {
    _getDefaultTapeBundle = _async_to_generator(function(tapeBundle) {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    switch(tapeBundle){
                        case TapeBundle.ALL_ES5:
                            return [
                                3,
                                1
                            ];
                        case TapeBundle.DEBUG_ES5:
                            return [
                                3,
                                3
                            ];
                        case TapeBundle.DASH_WEBVTT_ES5:
                            return [
                                3,
                                5
                            ];
                        case TapeBundle.DASH_WEBVTT_CEA_ES5:
                            return [
                                3,
                                7
                            ];
                        case TapeBundle.HLS_WEBVTT_ES5:
                            return [
                                3,
                                9
                            ];
                        case TapeBundle.HLS_WEBVTT_CEA_ES5:
                            return [
                                3,
                                11
                            ];
                        case TapeBundle.ALL_ESNEXT:
                            return [
                                3,
                                13
                            ];
                        case TapeBundle.DEBUG_ESNEXT:
                            return [
                                3,
                                15
                            ];
                        case TapeBundle.DASH_WEBVTT_ESNEXT:
                            return [
                                3,
                                17
                            ];
                        case TapeBundle.DASH_WEBVTT_CEA_ESNEXT:
                            return [
                                3,
                                19
                            ];
                        case TapeBundle.HLS_WEBVTT_ESNEXT:
                            return [
                                3,
                                21
                            ];
                        case TapeBundle.HLS_WEBVTT_CEA_ESNEXT:
                            return [
                                3,
                                23
                            ];
                    }
                    return [
                        3,
                        25
                    ];
                case 1:
                    return [
                        4,
                        import(/* webpackChunkName: "tape-es5" */ '@sky-uk-ott/tape/es5')
                    ];
                case 2:
                    tapeModule = _state.sent();
                    return [
                        3,
                        25
                    ];
                case 3:
                    return [
                        4,
                        import(/* webpackChunkName: "tape-debug-es5" */ '@sky-uk-ott/tape/debug_es5')
                    ];
                case 4:
                    tapeModule = _state.sent();
                    return [
                        3,
                        25
                    ];
                case 5:
                    return [
                        4,
                        import(/* webpackChunkName: "tape-dash-webvtt-es5" */ '@sky-uk-ott/tape/dash_webvtt_es5')
                    ];
                case 6:
                    tapeModule = _state.sent();
                    return [
                        3,
                        25
                    ];
                case 7:
                    return [
                        4,
                        import(/* webpackChunkName: "tape-dash-webvtt-cea-es5" */ '@sky-uk-ott/tape/dash_webvtt-cea_es5')
                    ];
                case 8:
                    tapeModule = _state.sent();
                    return [
                        3,
                        25
                    ];
                case 9:
                    return [
                        4,
                        import(/* webpackChunkName: "tape-hls-webvtt-es5" */ '@sky-uk-ott/tape/hls_webvtt_es5')
                    ];
                case 10:
                    tapeModule = _state.sent();
                    return [
                        3,
                        25
                    ];
                case 11:
                    return [
                        4,
                        import(/* webpackChunkName: "tape-hls-webvtt-cea-es5" */ '@sky-uk-ott/tape/hls_webvtt-cea_es5')
                    ];
                case 12:
                    tapeModule = _state.sent();
                    return [
                        3,
                        25
                    ];
                case 13:
                    return [
                        4,
                        import(/* webpackChunkName: "tape-esNext" */ '@sky-uk-ott/tape/esNext')
                    ];
                case 14:
                    tapeModule = _state.sent();
                    return [
                        3,
                        25
                    ];
                case 15:
                    return [
                        4,
                        import(/* webpackChunkName: "tape-debug-esNext" */ '@sky-uk-ott/tape/debug_esNext')
                    ];
                case 16:
                    tapeModule = _state.sent();
                    return [
                        3,
                        25
                    ];
                case 17:
                    return [
                        4,
                        import(/* webpackChunkName: "tape-dash-webvtt-esNext" */ '@sky-uk-ott/tape/dash_webvtt_esNext')
                    ];
                case 18:
                    tapeModule = _state.sent();
                    return [
                        3,
                        25
                    ];
                case 19:
                    return [
                        4,
                        import(/* webpackChunkName: "tape-dash-webvtt-cea-esNext" */ '@sky-uk-ott/tape/dash_webvtt-cea_esNext')
                    ];
                case 20:
                    tapeModule = _state.sent();
                    return [
                        3,
                        25
                    ];
                case 21:
                    return [
                        4,
                        import(/* webpackChunkName: "tape-hls-webvtt-esNext" */ '@sky-uk-ott/tape/hls_webvtt_esNext')
                    ];
                case 22:
                    tapeModule = _state.sent();
                    return [
                        3,
                        25
                    ];
                case 23:
                    return [
                        4,
                        import(/* webpackChunkName: "tape-hls-webvtt-cea-esNext" */ '@sky-uk-ott/tape/hls_webvtt-cea_esNext')
                    ];
                case 24:
                    tapeModule = _state.sent();
                    return [
                        3,
                        25
                    ];
                case 25:
                    return [
                        2,
                        tapeModule
                    ];
            }
        });
    });
    return _getDefaultTapeBundle.apply(this, arguments);
}
export function getTapeBundle(playerConfig, device, subtitlesFormat) {
    if (Boolean(playerConfig.useDebug)) {
        if (isIon()) {
            return TapeBundle.DEBUG_ESNEXT;
        } else {
            return TapeBundle.DEBUG_ES5;
        }
    }
    var tapeBundle = null;
    var isSafari = device ? isSafariDesktop(device.deviceInfo, device.type) : false;
    var needsWebVTT = subtitlesFormat.includes(TextTrackMimeType.WebVTT);
    var needCEA = subtitlesFormat.includes(TextTrackMimeType.CEA_608) || subtitlesFormat.includes(TextTrackMimeType.CEA_708);
    if (isSafari) {
        if (needsWebVTT) {
            tapeBundle = TapeBundle.HLS_WEBVTT_ES5;
            if (needCEA) {
                tapeBundle = TapeBundle.HLS_WEBVTT_CEA_ES5;
            }
        } else {
            tapeBundle = TapeBundle.ALL_ES5;
        }
    } else if (isIon()) {
        if (needsWebVTT) {
            tapeBundle = TapeBundle.DASH_WEBVTT_ESNEXT;
            if (needCEA) {
                tapeBundle = TapeBundle.DASH_WEBVTT_CEA_ESNEXT;
            }
        } else {
            tapeBundle = TapeBundle.ALL_ESNEXT;
        }
    } else {
        if (needsWebVTT) {
            tapeBundle = TapeBundle.DASH_WEBVTT_ES5;
            if (needCEA) {
                tapeBundle = TapeBundle.DASH_WEBVTT_CEA_ES5;
            }
        } else {
            tapeBundle = TapeBundle.ALL_ES5;
        }
    }
    if (!tapeBundle) {
        tapeBundle = TapeBundle.ALL_ES5;
    }
    return tapeBundle;
}

//# sourceMappingURL=tape-player-loader.js.map